import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=66fda9dd&scoped=true&"
import script from "./AvatarGroup.vue?vue&type=script&lang=ts&"
export * from "./AvatarGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=66fda9dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fda9dd",
  null
  
)

export default component.exports